
//Data imports
import AccessMatrix from '@/router/access-matrix';
import FeatureKeys from "@/helpers/Constants/FeatureKeys";

//view and component imports
import Title_Article from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Article.vue";
import Title_JobCategory from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_JobCategory.vue";
import Title_Machine from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Machine.vue";
import Title_MachineModel from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_MachineModel.vue";
import Title_MachineType from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_MachineType.vue";
import Title_Supplier from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Supplier.vue";
import Title_Unit from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Unit.vue";
const RouterView = () => import('@/views/landingpages/RouterView.vue')
const MachineTypes = () => import('@/views/pim/machinetypes/AdminMachineTypes');
const ViewMachineType = () => import('@/views/pim/machinetypes/ViewMachineTypeContainer.vue')
const ViewMachineTypeInfo = () => import('@/views/pim/machinetypes/ViewMachineTypeInfo.vue')
const ViewMachineTypeResources = () => import('@/views/pim/machinetypes/ViewMachineTypeResources.vue')
const ViewMachineTypeModelList = () => import('@/views/pim/machinetypes/ViewMachineTypeModelList.vue')
const ViewMachineTypeMachineList = () => import('@/views/pim/machinetypes/ViewMachineTypeMachineList.vue')
const MachineModels = () => import('@/views/pim/machinemodels/AdminMachineModels');
const NewMachineModel = () => import('@/views/pim/machinemodels/NewMachineModel.vue')
const ViewMachineModel = () => import('@/views/pim/machinemodels/ViewMachineModelContainer.vue')
const ViewMachineModelInfo = () => import('@/views/pim/machinemodels/ViewMachineModelInfo.vue')
const ViewMachineModelCommonParts = () => import('@/views/pim/machinemodels/ViewMachineModelCommonParts2.vue')
const ViewMachineModelResources = () => import('@/views/pim/machinemodels/ViewMachineModelResources.vue')
//const ViewMachineModelMachineList = () => import('@/views/pim/machinemodels/ViewMachineModelMachineList.vue')
const Suppliers = () => import('@/views/pim/suppliers/AdminSuppliers');
const NewSupplier = () => import('@/views/pim/suppliers/NewSupplier.vue')
const ViewSupplier = () => import('@/views/pim/suppliers/ViewSupplierContainer.vue')
const ViewSupplierInfo = () => import('@/views/pim/suppliers/ViewSupplierInfo.vue')
const ViewSupplierResources = () => import('@/views/pim/suppliers/ViewSupplierResources.vue')
const ViewSupplierFailureCodeList = () => import('@/views/pim/suppliers/ViewSupplierFailureCodeList.vue')
const ViewSupplierModelList = () => import('@/views/pim/suppliers/ViewSupplierModelList.vue')
const ViewSupplierMachineList = () => import('@/views/pim/suppliers/ViewSupplierMachineList.vue')
const Articles = () => import('@/views/pim/articles/AdminArticles.vue')
const ViewArticle = () => import('@/views/pim/articles/ViewArticleContainer.vue')
const ViewArticleInfo = () => import('@/views/pim/articles/ViewArticleInfo.vue')
const ViewArticleResources = () => import('@/views/pim/articles/ViewArticleResources.vue')
const NewArticle = () => import('@/views/pim/articles/NewArticle.vue')
const ViewArticleJobCategoryList = () => import('@/views/pim/articles/ViewArticleJobCategoryList');
const ArticleLogList = () => import('@/views/pim/articles/ArticleLogList.vue')
const JobCategories = () => import('@/views/pim/jobcategory/AdminJobCategoryList');
const ViewJobCategoryContainer = () => import('@/views/pim/jobcategory/ViewJobCategoryContainer.vue')
const ViewJobCategoryInfo = () => import('@/views/pim/jobcategory/ViewJobCategoryInfo.vue')
/*
const Documents = () => import('@/views/pim/documents/AdminDocuments.vue')
const NewDocument = () => import('@/views/pim/documents/NewDocument.vue')
const ViewDocument = AdminPage
const ViewDocumentInfo = () => import('@/views/pim/documents/ViewDocument.vue')
const ViewDocumentRelations = () => import('@/views/pim/documents/ViewDocumentRelations.vue')
*/
//machine goup
const AdminMachines = () => import("@/views/admin/machines/AdminMachineList.vue");
const ViewMachine = () => import("@/views/admin/machines/ViewMachineContainer.vue");
const ViewMachineInfo = () => import("@/views/admin/machines/ViewMachineInfo.vue");
const ViewMachineJobs = () => import("@/views/admin/machines/ViewMachineJobs.vue");
const ViewMachineResources = () => import("@/views/admin/machines/ViewMachineResources.vue");
const ViewMachineLogList = () => import("@/views/admin/machines/ViewMachineLogList.vue");
//unit
const AdminUnitList = () => import("@/views/pim/units/AdminUnitList.vue");
const ViewUnit = () => import("@/views/pim/units/ViewUnitContainer.vue");
const ViewUnitInfo = () => import("@/views/pim/units/ViewUnitInfo.vue");
const ViewUnitMachines = () => import("@/views/pim/units/ViewUnitMachines.vue");
const ViewUnitLogList = () => import("@/views/pim/units/ViewUnitLogList.vue");

//Export item
const trunk = {
  meta: {
    authorize: AccessMatrix.PimTrunk.module,
    display: { key: "servicesystem.pages.page_titles.products" },
    icon: "mdi-package-variant",
  },
  name: "PIM",
  // redirect: { name: 'PimHome', query: { filter: 'filter' } }, //the query here automatically opens the filter section
  redirect: { name: 'MachineModels' },
  path: "/pim",
  component: RouterView,
  children: [
    /* {
       meta: {
         authorize: AccessMatrix.AdminTrunk.module,
         display: { key: "servicesystem.pages.page_titles.pim_fullname" },
         icon: "mdi-package-variant",
       },
       path: "fp",
       name: "PimHome",
       component: PimFrontPage,
     },*/
    {
      meta: {
        authorize: AccessMatrix.PimTrunk.module,
        display: { key: "servicesystem.pages.page_titles.admin_machines_articles" },
        icon: "$article",
        overrides: {
          header: {
            buttons: ['NewEntityBtn'],
          },
        },
        newEntityBtnTo: { name: 'NewArticle', params: { articleId: 0 } },
      },
      path: 'articles',
      name: 'Articles',
      component: Articles,
      children: [
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            display: {
              key: "servicesystem.common_objects.commonterms.new_object",
              okey: "servicesystem.common_objects.article.article"
            },
            icon: "$article",
            overrides: {
              sidebar: false,
              headercard: false,
            }
          },
          path: 'new/:articleId',
          name: 'NewArticle',
          component: NewArticle,
        },
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            display: { key: "servicesystem.pages.page_titles.admin_machines_article" },
            icon: "$article",
            overrides: {
              sidebar: false,
              headercard: false,
              title: Title_Article,
            },
            contextMenu: true
          },
          path: ':articleId?/:articleNumber',
          name: 'ViewArticle',
          component: ViewArticle,
          redirect: { name: 'ViewArticleInfo' },
          children: [
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.info" },
                icon: "mdi-home",
              },
              path: "info",
              name: "ViewArticleInfo",
              component: ViewArticleInfo,
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.document.resources" },
                icon: "mdi-folder-open",
              },
              path: "resources",
              name: "ViewArticleResources",
              component: ViewArticleResources
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.pages.page_titles.admin_logs" },
                icon: "mdi-timeline-text",
              },
              name: 'ArticleLogs',
              path: 'logs/:logId?',
              component: ArticleLogList,
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.pages.page_titles.admin_job_categories" },
                icon: "$job_categories",
              },
              path: 'job-categories',
              name: 'ViewArticleJobCategoryList',
              component: ViewArticleJobCategoryList,
            },
          ],
        },
      ],
    },
    {
      meta: {
        authorize: AccessMatrix.PimTrunk.module,
        display: { key: "servicesystem.pages.page_titles.admin_job_categories" },
        icon: "$job_categories",
        overrides: {
          header: {
            buttons: ["NewDialogTriggerBtn"]
          },
        },
      },
      path: 'job-categories',
      name: 'JobCategories',
      component: JobCategories,
      children: [
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            display: { key: "servicesystem.pages.page_titles.admin_job_category" },
            icon: "$job_categories",
            overrides: {
              sidebar: false,
              headercard: false,
              title: Title_JobCategory
            },
            contextMenu: 'Hidden',
          },
          path: ':categoryId',
          name: 'ViewJobCategory',
          component: ViewJobCategoryContainer,
          redirect: { name: 'ViewJobCategoryInfo' },
          children: [
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.info" },
                icon: "mdi-home",
                overrides: {
                  header: {
                    buttons: ['ArticlePickerBtn', 'ToggleJobCategoryActiveBtn'],
                  },
                },
              },
              path: "info",
              name: "ViewJobCategoryInfo",
              component: ViewJobCategoryInfo,
            },
          ],
        },
      ],
    },
    {
      meta: {
        authorize: AccessMatrix.PimTrunk.module,
        display: { key: "servicesystem.pages.page_titles.admin_machines_models" },
        icon: "$machine_model",
        overrides: {
          header: {
            buttons: ['NewEntityBtn'],
          },
        },
        newEntityBtnTo: { name: 'NewMachineModel', params: { modelId: 0 } },
      },
      path: 'machine-models',
      name: 'MachineModels',
      component: MachineModels,
      children: [
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            display: {
              key: "servicesystem.common_objects.commonterms.new_object",
              okey: "servicesystem.common_objects.model.model"
            },
            icon: "$machine_model",
            overrides: {
              sidebar: false,
              headercard: false,
            }
          },
          path: 'new/:modelId',
          name: 'NewMachineModel',
          component: NewMachineModel,
        },
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            display: { key: "servicesystem.pages.page_titles.admin_machines_model" },
            icon: "$machine_model",
            contextMenu: true,
            overrides: {
              sidebar: false,
              headercard: false,
              title: Title_MachineModel,
            }
          },
          path: ":modelId",
          name: "ViewMachineModel",
          component: ViewMachineModel,
          redirect: { name: 'ViewMachineModelInfo' },
          children: [
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.info" },
                icon: "mdi-home",
                overrides: {
                  header: {
                    buttons: ['ToggleMachineModelActiveBtn'],
                  },
                },
              },
              path: "info",
              name: "ViewMachineModelInfo",
              component: ViewMachineModelInfo
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.document.resources" },
                icon: "mdi-folder-open",
              },
              path: "resources",
              name: "ViewMachineModelResources",
              component: ViewMachineModelResources
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "translate.commonparts" },
                icon: "$article",
                overrides: {
                  header: {
                    buttons: ['ArticlePickerBtn'],
                  },
                },
              },
              path: "common-parts",
              name: "ViewMachineModelCommonParts",
              component: ViewMachineModelCommonParts
            },
            /*
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                displayName: "Machines",
                icon: "$machine",
                overrides: {
                  header: {
                    buttons: ['NewDialogTriggerBtn'],
                  },
                },
              },
              path: "machine-list/:machineId?",
              name: "ViewMachineModelMachineList",
              component: ViewMachineModelMachineList
            },
            */
          ],
        },
      ],
    },
    {
      meta: {
        authorize: AccessMatrix.PimTrunk.module,
        display: { key: "servicesystem.pages.page_titles.admin_machines_categories" },
        icon: "$machine_categories",
        overrides: {
          header: {
            buttons: ['NewCustomerGroupBtn'],
          },
        },
      },
      path: 'machine-types',
      name: 'MachineTypes',
      component: MachineTypes,
      children: [
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            display: { key: "servicesystem.pages.page_titles.admin_machines_category" },
            icon: "$machine_categories",
            contextMenu: true,
            overrides: {
              sidebar: false,
              headercard: false,
              title: Title_MachineType,
            }
          },
          path: ':typeId',
          name: 'ViewMachineType',
          component: ViewMachineType,
          redirect: { name: 'ViewMachineTypeInfo' },
          children: [
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.info" },
                icon: "mdi-home",
                overrides: {
                  header: {
                    buttons: ['ToggleMachineTypeActiveBtn'],
                  },
                },
              },
              path: "info",
              name: "ViewMachineTypeInfo",
              component: ViewMachineTypeInfo,
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.document.resources" },
                icon: "mdi-folder-open",
              },
              path: "resources",
              name: "ViewMachineTypeResources",
              component: ViewMachineTypeResources
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.pages.page_titles.admin_machines_models" },
                icon: "$machine_model",
              },
              path: "model-list",
              name: "ViewMachineTypeModelList",
              component: ViewMachineTypeModelList
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.machine.machines" },
                icon: "$machine",
                /*
                overrides: {
                  header: {
                    buttons: ['NewDialogTriggerBtn'],
                  },
                },
                */
              },
              path: "machine-list/:machineId?",
              name: "ViewMachineTypeMachineList",
              component: ViewMachineTypeMachineList
            },
          ],
        },
      ],
    },
    {
      meta: {
        authorize: AccessMatrix.PimTrunk.module,
        display: { key: "servicesystem.pages.page_titles.admin_machines_suppliers" },
        icon: "$supplier",
        overrides: {
          header: {
            buttons: ['NewSupplierBtn'],
          },
        },
      },
      path: 'suppliers',
      name: 'Suppliers',
      component: Suppliers,
      children: [
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            display: {
              key: "servicesystem.common_objects.commonterms.new_object",
              okey: "servicesystem.common_objects.supplier.supplier"
            },
            icon: "$supplier",
            overrides: {
              sidebar: false,
              headercard: false,
            }
          },
          path: 'new/:supplierId',
          name: 'NewSupplier',
          component: NewSupplier,
        },
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            display: { key: "servicesystem.pages.page_titles.admin_machines_supplier" },
            icon: "$supplier",
            overrides: {
              sidebar: false,
              headercard: false,
              title: Title_Supplier,
            },
            contextMenu: true,
          },
          path: ':supplierId',
          name: 'ViewSupplier',
          component: ViewSupplier,
          redirect: { name: 'ViewSupplierInfo' },
          children: [
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.info" },
                icon: "mdi-home",
              },
              path: "info",
              name: "ViewSupplierInfo",
              component: ViewSupplierInfo,
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.document.resources" },
                icon: "mdi-folder-open",
              },
              path: "resources",
              name: "ViewSupplierResources",
              component: ViewSupplierResources
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.pages.page_titles.admin_machines_failure_codes" },
                icon: "$supplier_failure_code",
                overrides: {
                  header: {
                    buttons: ['NewSupplierFailureCodeBtn'],
                  },
                },
              },
              path: 'failure-codes',
              name: 'ViewSupplierFailureCodeList',
              component: ViewSupplierFailureCodeList,
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.pages.page_titles.admin_machines_models" },
                icon: "$machine_model",
              },
              path: "model-list",
              name: "ViewSupplierModelList",
              component: ViewSupplierModelList
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.machine.machines" },
                icon: "$machine",
                overrides: {
                  header: {
                    buttons: ['NewDialogTriggerBtn'],
                  },
                },
              },
              path: "machine-list/:machineId?",
              name: "ViewSupplierMachineList",
              component: ViewSupplierMachineList
            },
          ],
        },
      ],
    },
    /*
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.documents,
        display: { key: "servicesystem.pages.page_titles.admin_documents" },
        icon: "$documents",
        overrides: {
          header: {
            buttons: ['OldPageNewEntityBtn'],
          },
        },
        oldPageNewEntityBtnArgs: { name: 'NewDocument', params: { documentId: 0 } }, //only used on OldPageNewEntityBtn
      },
      path: "documents",
      name: "Documents",
      component: Documents,
      children: [
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            display: {
              key: "servicesystem.common_objects.commonterms.new_object",
              okey: "servicesystem.common_objects.document.document"
            },
            icon: "$documents",
            overrides: {
              sidebar: false,
              headercard: false,
            }
          },
          path: 'new/:documentId',
          name: 'NewDocument',
          component: NewDocument,
        },
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            display: { key: "servicesystem.pages.page_titles.admin_document" },
            icon: "$documents",
            overrides: {
              sidebar: false,
              headercard: false,
            }
            contextMenu: true,
          },
       
          path: 'documents/:documentId?',
          name: 'ViewDocument',
          component: ViewDocument,
          redirect: { name: 'ViewDocumentInfo' },
          children: [
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                displayName: 'Info',
                icon: "mdi-home",
                overrides: {
                }
              },
              path: "info",
              name: "ViewDocumentInfo",
              component: ViewDocumentInfo,
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                displayName: "Releations",
                icon: "mdi-file",
              },
              path: "releations",
              name: "ViewDocumentRelations",
              component: ViewDocumentRelations,
            },
          ],
        },
      ],
    },
    */
    {
      meta: {
        authorize: AccessMatrix.PimTrunk.module,
        display: { key: "servicesystem.pages.page_titles.admin_machines_list" },
        icon: "$machine_list",
        overrides: {
          header: {
            buttons: ['NewDialogTriggerBtn'],
          },
        },
      },
      path: "machine-list",
      name: "MachineList",
      component: AdminMachines,
      children: [
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            display: { key: "servicesystem.pages.page_titles.customer_view_machine" },
            icon: "$machine",
            contextMenu: true,
            overrides: {
              sidebar: false,
              headercard: false,
              title: Title_Machine,
            },
          },
          name: "ViewMachine",
          path: ":machineId",
          component: ViewMachine,
          redirect: { name: "MachineInfo" },
          children: [
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.info" },
                icon: "$info",
                overrides: {
                  header: {
                    buttons: ['ToggleMachineActiveBtn'],
                  },
                },
              },
              name: "MachineInfo",
              path: "info",
              component: ViewMachineInfo
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.document.resources" },
                icon: "mdi-folder-open",
              },
              name: "MachineResources",
              path: "resources/:documentId?",
              component: ViewMachineResources
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.pages.page_titles.admin_logs" },
                icon: "mdi-timeline-text",
              },
              name: 'MachineLogs',
              path: 'logs/:logId?',
              component: ViewMachineLogList,
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.job.jobs" },
                icon: "$job",
                overrides: {
                  header: {
                    buttons: ["NewJobBtn"]
                  }
                }
              },
              name: "MachineJobs",
              path: "jobs/:jobId?",
              component: ViewMachineJobs
            },
          ]
        }
      ]
    },

    {
      meta: {
        featureEnabled: FeatureKeys.Unit,
        authorize: AccessMatrix.AdminTrunk.machines_branch,
        display: { key: "servicesystem.common_objects.unit.units" },
        icon: "$unit",
        overrides: {
          header: {
            buttons: ["NewDialogTriggerBtn"]
          }
        }
      },
      path: "units",
      name: "UnitList",
      component: AdminUnitList,
      children: [
        {
          meta: {
            authorize: AccessMatrix.PimTrunk.module,
            icon: "$unit",
            contextMenu: true,
            overrides: {
              sidebar: false,
              headercard: false,
              title: Title_Unit,
            },
          },
          name: "ViewUnit",
          path: ":unitId",
          component: ViewUnit,
          redirect: { name: "UnitInfo" },
          children: [
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.commonterms.info" },
                icon: "$info",
              },
              name: "UnitInfo",
              path: "info",
              component: ViewUnitInfo
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.common_objects.machine.machines" },
                icon: "$machine",
                overrides: {
                  header: {
                    buttons: ['MachinePickerBtn'],
                  },
                },
              },
              name: "UnitMachines",
              path: "machines",
              component: ViewUnitMachines
            },
            {
              meta: {
                authorize: AccessMatrix.PimTrunk.module,
                display: { key: "servicesystem.pages.page_titles.admin_logs" },
                icon: "mdi-timeline-text",
              },
              name: 'UnitLogs',
              path: 'logs',
              component: ViewUnitLogList,
            },

          ]
        }
      ]
    },

  ],
};
export default trunk;